import { Button } from 'antd';
import styled, { keyframes, css } from 'styled-components';

const highlightAnimation = keyframes`
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(138, 43, 226, 0.7), 0 0 0 0 rgba(65, 105, 225, 0.7);
  }
  50% {
    box-shadow: 0 0 0 3px rgba(138, 43, 226, 0.4), 0 0 0 6px rgba(65, 105, 225, 0.2);
  }
`;

export const StyledItem = styled.div`
  cursor: pointer;
`;

export const Controls = styled.div`
  margin-bottom: 16px;
  display: flex;
  gap: 8px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 10px;
  padding-bottom: 5px;
`;

export const StyledDashboardRemoveButton = styled(Button)`
  position: absolute;
  top: 8px;
  right: -4px;
  background-color: #f3f3f3;
  z-index: 99;
  border-right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  box-shadow:
    -2px 0 4px rgb(0 0 0 / 10%),
    0 2px 4px rgb(0 0 0 / 10%);
`;

export const StyledWhatsNew = styled.div`
  position: absolute;
  right: 10px;
  z-index: 99;
`;

export const StyledReportButton = styled(Button)<{ $highlight?: boolean }>`
  position: relative;
  transition: all 0.3s ease;

  ${({ $highlight }) =>
    $highlight &&
    css`
      animation: ${highlightAnimation} 2s ease-in-out;
      border: 2px solid transparent;
      background-image: linear-gradient(white, white), linear-gradient(135deg, #8a2be2, #4169e1);
      background-origin: border-box;
      background-clip: padding-box, border-box;
    `}
`;
